module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"誉诚防护":"Yucheng Protection","热门产品":"Hot Products","誉诚数据":"Yucheng Data","誉诚产品":"Yucheng Products","快速链接":"Quick Link","我们的工厂":"Our Factory","新闻中心":"News Center"},"zh":{"誉诚防护":"誉诚防护","热门产品":"热门产品","誉诚数据":"誉诚数据","誉诚产品":"誉诚产品","快速链接":"快速链接","我们的工厂":"我们的工厂","新闻中心":"新闻中心"}}')
  delete Component.options._Ctor
}
